import React from 'react';
import { useTranslation } from 'react-i18next';
import { useCreateClientUser } from 'api/client-users/use-create-client-user';
import { UserRole, withRoleGuard } from 'shared/hocs/with-role-guard.tsx';
import { ClientUserForm } from 'components/client-users/client-user-form';
import type { IClientUserFormFields } from 'components/client-users/client-user-form/types';
import { FormDrawerWithButton, EFormDrawerWithButtonIconType } from 'components/common/form-drawer-with-button';
import type { IAddClientUserButtonProps } from './types';

const AddClientUserButtonComponent: React.FC<IAddClientUserButtonProps> = (props) => {
  const { clientId } = props;

  const { t } = useTranslation();
  const { mutateAsync: createClientUser, isLoading } = useCreateClientUser();

  const handleFinish = async (values: IClientUserFormFields) => {
    await createClientUser({
      name: values.name,
      email: values.email,
      clientId,
    });
  };

  return (
    <FormDrawerWithButton
      formComponent={ClientUserForm}
      title={t('client:add_access')}
      isLoading={isLoading}
      iconType={EFormDrawerWithButtonIconType.CREATE}
      buttonType='text'
      onFinish={handleFinish}
    />
  );
};

export const AddClientUserButton = withRoleGuard<IAddClientUserButtonProps>(AddClientUserButtonComponent, [
  UserRole.admin,
  UserRole.assistant,
  UserRole.customer_manager,
]);
